window.addEventListener('load', function () {
  configureSwipers();
  configureScrollToTop();
  configureDealOfTheMonth();

  // POST commands to YouTube or Vimeo API
  function postMessageToPlayer(player, command) {
    console.log(player);
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
  }

  function toggleVideo(videoType, player, video, control) {
    if (videoType === "js-youtube") {
      switch (control) {
        case "play":
          player.contentWindow.postMessage('{"event":"command", "func":"playVideo", "args":""}', '*');
          break;
        case "pause":
          player.contentWindow.postMessage('{"event":"command", "func":"pauseVideo", "args":""}', '*');
          break;
      }
    } else if (videoType === "js-video") {
      if (video != null) {
        if (control === "play") {
          video.play();
        } else {
          video.pause();
        }
      }
    }
  }

  document.querySelectorAll('.video-panel__toggle').forEach((toggle) => {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      const videoContent = this.closest('.video-panel__media').querySelector('.video-panel__video-container');
      const video = videoContent.querySelector('video');
      const player = videoContent.querySelector('iframe');
      videoContent.classList.add('active');
      toggleVideo(videoContent.dataset.type, player, video, 'play');
    });
  });

  this.document.querySelectorAll('.video-panel__close').forEach((toggle) => {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      const videoContent = this.closest('.video-panel__media').querySelector('.video-panel__video-container');
      const video = videoContent.querySelector('video');
      const player = videoContent.querySelector('iframe');
      videoContent.classList.remove('active');
      toggleVideo(videoContent.dataset.type, player, video, 'pause');
    });
  });

  this.document.querySelectorAll('.double-accordion-link').forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const title = link.textContent;
      const content = link.nextElementSibling.innerHTML;
      const collapseContent = link.closest('.pe-double-accordion').querySelector('.pe--double-collapse__content');

      collapseContent.querySelector('.double-collapse__title').textContent = title;
      collapseContent.querySelector('.double-collapse__content').innerHTML = content;
    });
  });
});

function configureScrollToTop() {
  window.addEventListener('scroll', toggleScrollToTopVisibility);

  const scrollToTopButton = document.getElementById('goTop');
  scrollToTopButton.addEventListener('click', scrollToTop);

  function scrollToTop() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.body.scrollIntoView({
      behavior: prefersReducedMotion ? 'instant' : 'smooth',
      block: 'start',
    });
  }

  function toggleScrollToTopVisibility() {
    if (window.scrollY >= 300) {
      scrollToTopButton.setAttribute('aria-hidden', false);
    } else {
      scrollToTopButton.setAttribute('aria-hidden', true);
    }
  }
}

function configureSwiper(swiperContainer) {
  const optOut = swiperContainer.hasAttribute('data-opt-out');
  if (optOut) {
    return;
  }

  const swiper = swiperContainer.querySelector('.swiper');
  const prevButton = swiperContainer.querySelector('.swiper-button-prev');
  const nextButton = swiperContainer.querySelector('.swiper-button-next');
  const scrollbar = swiperContainer.querySelector('.swiper-scrollbar');

  const defaultMobileSettings = { slidesPerView: 1, spaceBetween: 0 };
  let mobileSettings = { ...defaultMobileSettings };
  const mobileSettingsJSON = swiper.getAttribute('data-mobile-settings');
  if (mobileSettingsJSON) {
    const parsedSettings = JSON.parse(mobileSettingsJSON);
    mobileSettings = { ...mobileSettings, ...parsedSettings };
  }

  const defaultDesktopSettings = { slidesPerView: 4, spaceBetween: 40 };
  let desktopSettings = { ...defaultDesktopSettings };
  const desktopSettingsJSON = swiper.getAttribute('data-desktop-settings');
  if (desktopSettingsJSON) {
    const parsedSettings = JSON.parse(desktopSettingsJSON);
    desktopSettings = { ...desktopSettings, ...parsedSettings };
  }

  const defaultBaseSettings = { loop: true };
  let baseSettings = { ...defaultBaseSettings };
  const baseSettingsJSON = swiper.getAttribute('data-base-settings');
  if (baseSettingsJSON) {
    const parsedSettings = JSON.parse(baseSettingsJSON);
    baseSettings = { ...baseSettings, ...parsedSettings };
  }

  baseSettings = {
    ...baseSettings,
    breakpoints: {
      320: mobileSettings,
      1024: desktopSettings,
    },
    navigation: {
      prevEl: prevButton,
      nextEl: nextButton,
    },
    scrollbar: {
      el: scrollbar,
      draggable: true,
    },
  };

  const settings = Object.assign({}, baseSettings, window.innerWidth < 1024 ? mobileSettings : desktopSettings);
  new Swiper(swiper, settings);
}

function configureSwipers() {
  document.querySelectorAll('.swiper-container').forEach((swiperContainer) => {
    configureSwiper(swiperContainer);
  });
}

function configureDealOfTheMonth() {
  const elements = document.querySelectorAll('[data-component="deal-of-the-month"]');
  elements.forEach((dealOfTheMonth) => {
    const isDeal = dealOfTheMonth.dataset.isFeaturedDeal;
    const startDate = dealOfTheMonth.dataset.dealStartDate;
    const endDate = dealOfTheMonth.dataset.dealEndDate;

    if (!isDeal || !startDate || !endDate) {
      ('Returning early');
      return;
    }

    const dealStarted = new Date(startDate) < new Date();
    if (!dealStarted) {
      return;
    }

    const dealCountdown = dealOfTheMonth.querySelector('#deal-countdown');
    const dealEnd = new Date(endDate).getTime();

    const interval = setInterval(function () {
      const now = new Date().getTime();
      const distance = dealEnd - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      dealCountdown.innerHTML = `Ends in ${days}d ${hours}h ${minutes}m ${seconds}s`;

      if (distance < 0) {
        clearInterval(interval);
        dealCountdown.innerHTML = 'EXPIRED';
      }
    }, 1000);
  });
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            configureSwiper(this.querySelector('.swiper-container'));
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

document.addEventListener('click', (e) => {
  const accountMenuWrapper = document.getElementById('account-menu-wrapper');
  if (accountMenuWrapper) {
    const target = e.target;
    const isAccountMenu = target.closest('#account-menu-wrapper') || target.matches('#account-menu-wrapper');

    if (!isAccountMenu && accountMenuWrapper.hasAttribute('open')) {
      accountMenuWrapper.removeAttribute('open');
    }
  }
});

document.addEventListener('click', (e) => {
  const headerMenu = e.target.closest('header-menu');
  if (headerMenu) {
    // Close all other menus
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu === headerMenu) return;
      menu.mainDetailsToggle.removeAttribute('open');
    });
  } else {
    // Close all menus
    document.querySelectorAll('header-menu').forEach((menu) => {
      menu.mainDetailsToggle.removeAttribute('open');
    });
  }
})


window.addEventListener('load', () => {
  setTimeout(() => {
    if (window.location.hash) {
      const element = document.querySelector(window.location.hash);
      if (element) {

        const details = element.closest('details');
        if (details) {
          details.open = true;
        }

        const headerOffset = document.querySelector('[id$="__header"]')?.offsetHeight ?? 0;
        const offset = headerOffset + 24;

        const elementPosition = element.getBoundingClientRect().top + window.scrollY
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'auto'
        });
      }
    };
  }, 500);
});
